import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'qs';
import { CalendarAddIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CalendarButton = _ref => {
  var appearance = _ref.appearance,
    title = _ref.title,
    startTime = _ref.startTime,
    endTime = _ref.endTime,
    listing = _ref.listing,
    location = _ref.location,
    onClick = _ref.onClick,
    className = _ref.className,
    endpoints = _ref.endpoints,
    fromModal = _ref.fromModal;
  var isIcon = appearance === 'icon';
  var handleCalendarClick = () => {
    onClick(true, fromModal);
    window.location = "".concat(endpoints.calendarGeneratorUrl, "?").concat(queryString.stringify({
      title,
      location,
      startDate: startTime,
      endDate: endTime,
      url: listing.url,
      price: listing.price,
      beds: listing.beds,
      baths: listing.baths,
      parking: listing.parking
    }));
  };
  return ___EmotionJSX(Button, {
    className: className,
    appearance: isIcon ? 'secondaryNeutral' : 'primary',
    size: "small",
    icon: isIcon && ___EmotionJSX(CalendarAddIcon, null),
    onClick: handleCalendarClick
  }, !isIcon && 'Add to calendar');
};
CalendarButton.propTypes = {
  appearance: PropTypes.oneOf(['icon', 'full']),
  title: PropTypes.string,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string,
  listing: PropTypes.shape({
    url: PropTypes.string,
    price: PropTypes.string,
    beds: PropTypes.number,
    baths: PropTypes.number,
    parking: PropTypes.number
  }).isRequired,
  location: PropTypes.string,
  className: PropTypes.string,
  fromModal: PropTypes.bool,
  onClick: PropTypes.func,
  endpoints: PropTypes.shape({
    calendarGeneratorUrl: PropTypes.string
  })
};
CalendarButton.defaultProps = {
  appearance: 'icon',
  title: 'Open Home',
  endTime: null,
  location: null,
  className: null,
  onClick: () => {},
  fromModal: false,
  endpoints: {
    calendarGeneratorUrl: '/listing-event'
  }
};
export default withAllhomesContext('endpoints')(CalendarButton);